import type { SVGAttributes } from 'react';

export function CollectedIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props} viewBox="0 0 32 32">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M12.667 18.334c0 1.293 1 2.333 2.227 2.333H17.4c1.067 0 1.934-.907 1.934-2.04 0-1.213-.534-1.653-1.32-1.933L14 15.294c-.786-.28-1.32-.707-1.32-1.934 0-1.12.867-2.04 1.934-2.04h2.506c1.227 0 2.227 1.04 2.227 2.334M16 10v12"
				opacity=".4"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M29.333 16c0 7.36-5.973 13.333-13.333 13.333S2.667 23.36 2.667 16 8.64 2.667 16 2.667M22.667 4v5.333H28m1.333-6.666-6.666 6.666"
			/>
		</svg>
	);
}
